import {SlChangeEvent} from '@shoelace-style/shoelace/events/sl-change';
import {SlRadio, SlRadioGroup} from '@shoelace-style/shoelace/shoelace';
import {notNull} from '../../../../../../library/clxProductNet/assets/js/modules/common/assert';
import {MicroConversionTrackingEventsEnum} from '../../common/trackingMicroconversion/Model/EventProductCustomizationEnum';
import ProductCustomizationConfigModel from '../Model/productCustomizationConfigModel';
import CustomizationPricingOverviewComponent from './customizationPricingOverviewComponent';

export default class ColorAndSizeComponent extends HTMLElement {
    private refreshOverviewUI: CustomizationPricingOverviewComponent;
    private readonly config: ProductCustomizationConfigModel;
    private currentlySelectedColorLabel: HTMLDivElement;
    private colorSizes: HTMLDivElement;

    constructor() {
        super();

        this.refreshOverviewUI = notNull(document.querySelector<CustomizationPricingOverviewComponent>('#pricing-overview'));
        this.config = ProductCustomizationConfigModel.getInstance();
        this.currentlySelectedColorLabel = notNull(this.querySelector<HTMLDivElement>('.color-label.current'));
        this.colorSizes = notNull(this.querySelector<HTMLDivElement>('.article-sizes'));
    }
    connectedCallback() {
        this.attachEventListenersColorUI();
    }

    disconnectedCallback() {
        this.detachEventListenersColorUI();
    }

    private handleItemMoreClick = async () => {
        this.showAllColors();
    };

    private handleItemClick = (item: HTMLDivElement) => async () => {
        await this.changeCurrentColor(parseInt(item.dataset.color!));
    };

    private handleItemMouseEnter = (colorid: string | undefined) => () => {
        this.toggleDisplay(this.currentlySelectedColorLabel, false);
        this.toggleDisplay(this.querySelector(`.color-label.color-${colorid}`), true);
    };

    private handleItemMouseLeave = (colorid: string | undefined) => () => {
        this.toggleDisplay(this.querySelector(`.color-label.color-${colorid}`), false);
        this.toggleDisplay(this.currentlySelectedColorLabel, true);
    };

    private handleItemSlChange = async (event: SlChangeEvent) => {
        const target = event.target as SlRadioGroup;

        const groesseid = parseInt(target!.value);
        const currentlySelectedSize = target?.querySelector<SlRadio>('sl-radio[value="' + groesseid + '"]');
        this.config.setSize(groesseid, parseInt(currentlySelectedSize!.dataset!.artgroesseid!));

        const colorItem = notNull(this.querySelector<HTMLDivElement>('.article-colors .active'));
        colorItem.querySelector('div.current')!.classList.toggle('current');
        // @ts-ignore
        colorItem.querySelector('div.stock-' + event.target.value)!.classList.toggle('current');
        await this.refreshOverviewUI.refreshOverviewUIAndHandleErrors(this.config, MicroConversionTrackingEventsEnum.customization_configuration_change);
    };

    private attachEventListenersColorUI() {
        let colorImages = this.querySelectorAll<HTMLDivElement>('.article-colors .item');
        colorImages.forEach((item) => {
            if (item.classList.contains('more')) {
                item.addEventListener('click', this.handleItemMoreClick);
                return;
            }
            const colorid = item.dataset.color;
            item.addEventListener('mouseenter', this.handleItemMouseEnter(colorid));
            item.addEventListener('mouseleave', this.handleItemMouseLeave(colorid));
            item.addEventListener('click', this.handleItemClick(item));
        });

        const sizeRadios = this.colorSizes.querySelectorAll<SlRadioGroup>('sl-radio-group');
        sizeRadios.forEach((item) => {
            item.addEventListener('sl-change', this.handleItemSlChange);
        });
    }

    private detachEventListenersColorUI() {
        let colorImages = this.querySelectorAll<HTMLDivElement>('.article-colors .item');
        colorImages.forEach((item) => {
            if (item.classList.contains('more')) {
                item.removeEventListener('click', this.handleItemMoreClick);
                return;
            }
            const colorid = item.dataset.color;
            item.removeEventListener('mouseenter', this.handleItemMouseEnter(colorid));
            item.removeEventListener('mouseleave', this.handleItemMouseLeave(colorid));
            item.removeEventListener('click', this.handleItemClick(item));
        });

        const sizeRadios = this.colorSizes.querySelectorAll<SlRadioGroup>('sl-radio-group');
        sizeRadios.forEach((item) => {
            item.addEventListener('sl-change', this.handleItemSlChange);
        });
    }

    private showAllColors() {
        const colorContainer = this.querySelector<HTMLDivElement>('.article-colors');
        if (colorContainer) {
            colorContainer.classList.add('all-visible');
        }
    }

    private toggleDisplay(element: HTMLDivElement | null, show: boolean) {
        if (element) {
            element.style.display = show ? 'flex' : 'none';
        }
    }

    private async changeCurrentColor(color: number) {
        const newClassColor = `color-${color}`;
        this.currentlySelectedColorLabel.classList.remove('current');
        const activeItem = this.querySelector('.article-colors .item.active');
        if (activeItem) {
            activeItem.classList.remove('active');
        }
        const newColorLabel = this.querySelector(`.color-label.${newClassColor}`);
        if (newColorLabel) {
            newColorLabel.classList.add('current');
        }
        this.currentlySelectedColorLabel = this.querySelector('.color-label.current')!;
        const newActiveItem = this.querySelector(`.article-colors .item[data-color="${color}"]`);
        if (newActiveItem) {
            newActiveItem.classList.add('active');
        }

        this.colorSizes.querySelector('.artsize.current')?.classList.remove('current');

        let currentlySelectedColorSizes = this.colorSizes.querySelector<SlRadioGroup>('.artsize.' + newClassColor);
        if (currentlySelectedColorSizes) {
            currentlySelectedColorSizes.classList.add('current');
        }

        const groesseid = parseInt(currentlySelectedColorSizes!.value);
        const currentlySelectedSize = currentlySelectedColorSizes?.querySelector<SlRadio>('sl-radio[value="' + groesseid + '"]');
        this.config.setColor(color, groesseid, parseInt(currentlySelectedSize!.dataset!.artgroesseid!));
        await this.refreshOverviewUI.refreshOverviewUIAndHandleErrors(this.config, MicroConversionTrackingEventsEnum.customization_configuration_change);
    }
}
customElements.define('clx-customization-color-and-size', ColorAndSizeComponent);
